/** Placed KOTs remain history after kitchen completion; status is not a visibility gate. */
export const getPlacedKotGroups = (groups) => (Array.isArray(groups) ? groups : []).filter((group) => {
  const sequence = group?.sequence;
  return sequence != null && String(sequence).trim() !== "" &&
    Number.isInteger(Number(sequence)) && Number(sequence) >= 0 &&
    Array.isArray(group.items) && group.items.length > 0;
});
